import utils from '@src/common/utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    addFormSlot: true,
    viewFormSlot: true,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '领用单号',
        prop: 'collectionCode',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 24,
        align: 'center'
      },
      {
        label: '领用人',
        prop: 'name',
        type: 'select',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        filterable: true,
        dicData: [],
        rules: [
          { required: true, message: '请输入领用人', trigger: 'blur' }
        ]
      },
      {
        label: '领用时间',
        prop: 'collectionTime',
        type: 'datetime',
        value: '',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        },
        rules: [
          { required: true, message: '请选择领用时间', trigger: 'blur' }
        ]
      },
      {
        label: '用途',
        prop: 'collectionPurpose',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        align: 'center',
        rules: [
          { required: true, message: '请输入领用用途', trigger: 'blur' }
        ]
      },
      {
        label: '领用数量',
        prop: 'collectionNumber',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12,
        align: 'center'
      },
      {
        label: '归还数量',
        prop: 'returnNumber',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12,
        align: 'center',
        placeholder: '请选择区域'
      }
    ]
  }
}
export default tableOption